import { createSelector } from '@reduxjs/toolkit';
import { getSalesSpaceListState } from './getSalesSpaceListState';

export const getSelectedSalesSpaceChannelOrder = createSelector(
  getSalesSpaceListState,
  (channelList) => channelList.selectedSalesSpaceChannelOrder,
);
